import React, { Component } from 'react';

export default class TrainResult extends Component {
	componentDidMount() {
		document.getElementById('close-button').focus();
	}

	render() {
		return (
			<div>
				<div style={{fontSize: 'xx-large'}}>Train result</div>
				<div style={{fontSize: 'large', marginTop: 50}}>
					Right answers: {
						this.props.app.rightAnswers + ' of ' +
						this.props.app.answersCount }.
				</div>

				{this.props.app.wasTestCompleted ||
					<div>
						Questions count: {this.props.app.questionsCount}
					</div>
				}

				{this.props.app.rightAnswers === this.props.app.answersCount &&
					<div style={{fontSize: 'x-large',
								 color: 'green',
								 marginTop: 60}}>
						Good!
					</div>
				}

				<div style={{
						textAlign: 'right',
						position: 'absolute',
						bottom: 10,
						width: '90%' }}>
					<input
							id="close-button"
							type="button"
							value="Close"
							onClick={() => {
								this.props.app.setState({mode: 'mainPanel'});
							}} />
				</div>
			</div>
		);
	} // render
}



// WEBPACK FOOTER //
// ./src/TrainResult.js